module.exports = "/static/assets/b90566cbf96f1c45ab29b17c1264056b.png";